import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiertigacab() {



const cardData = {
  keyword: " Pune to Mumbai Ertiga Cabs ",

"headingDescription": "SRS Cab Service offers Pune to Mumbai Ertiga Cabs, providing a spacious, comfortable, and reliable travel solution for families, corporate travelers, and groups. Our well-maintained Ertiga vehicles, professional drivers, and timely pickups ensure a smooth journey from Pune to Mumbai. Ideal for airport transfers, corporate trips, weekend getaways, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a hassle-free and enjoyable ride.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is Mumbai’s iconic landmark overlooking the Arabian Sea. Travelers using Pune to Mumbai Ertiga Cabs from SRS Cab Service often visit this historic site for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a famous seaside promenade known for its breathtaking sunset views. Visitors using SRS Cab Service often enjoy leisurely walks along this scenic coastline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves located on an island near Mumbai. Travelers using SRS Cab Service often include this destination for historical and cultural exploration."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station features Victorian Gothic architecture. Visitors using SRS Cab Service often admire its grandeur and heritage significance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a lively coastal destination known for street food and leisure activities. Travelers using SRS Cab Service often visit to enjoy sunsets and local cuisine."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a renowned temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often seek blessings and spiritual serenity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque located on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit for spiritual significance and scenic beauty."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street in Mumbai known for shopping and cultural experiences. Travelers using SRS Cab Service often explore this area for dining and local souvenirs."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green space offering wildlife, trekking, and nature activities. Visitors using SRS Cab Service often enjoy outdoor recreation here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting major areas of Mumbai. Travelers using SRS Cab Service often take this route for scenic views and a smooth drive."
  }
],



services: [
{
name: "Ertiga Per Km Rate in Pune",
description: "Ertiga per km rate in Pune provides clear pricing for travel planning. Customers can check per kilometer rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Travel easily with Ertiga rental services."
},
{
name: "Pune to Mumbai Airport Ertiga Cab",
description: "Pune to Mumbai airport Ertiga cab offers comfortable 7 seater travel for airport transfers. Customers can book cabs for timely drop. Professional drivers ensure safe expressway journeys. Spacious seating enhances comfort. Transparent pricing ensures affordability. Travel easily with Ertiga airport cab services."
},
{
name: "Pune to Dadar Ertiga Cab Fare",
description: "Pune to Dadar Ertiga cab fare provides estimated pricing for intercity travel. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Travel easily with Ertiga cab services."
},
{
name: "Pune to Andheri Ertiga Taxi Fare",
description: "Pune to Andheri Ertiga taxi fare offers pricing for business and airport routes. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Travel easily with Ertiga taxi services."
},
{
name: "Pune to Mumbai One Way Ertiga Taxi Cab",
description: "Pune to Mumbai one way Ertiga taxi cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe expressway travel. Spacious seating enhances comfort. Transparent pricing ensures affordability. Travel easily with one way Ertiga cab services."
},
{
name: "Ertiga Cab in Pune",
description: "Ertiga cab in Pune provides comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Ertiga Cab for Mumbai Airport Drop",
description: "Ertiga cab for Mumbai airport drop offers reliable transfer for passengers. Customers can book cabs for timely airport travel. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with airport Ertiga cab services."
},
{
name: "Viman Nagar to Mumbai Cabs",
description: "Viman Nagar to Mumbai cabs provide convenient intercity travel for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Wagholi to Mumbai Cab Service",
description: "Wagholi to Mumbai cab service offers reliable transportation for long-distance travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Borivali Ertiga Cab",
description: "Pune to Borivali Ertiga cab offers comfortable 7 seater travel for long-distance routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Andheri Ertiga Cab",
description: "Pune to Andheri Ertiga cab provides convenient travel for business and airport routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Dadar Ertiga Cab",
description: "Pune to Dadar Ertiga cab offers reliable transportation for central Mumbai routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab offers comfortable 7 seater travel for families and groups. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe expressway travel. Spacious seating enhances comfort. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai 7 Seater Cab",
description: "Pune to Mumbai 7 seater cab provides spacious travel for families and group trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 7 seater cab services."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip offers convenient two-way travel options. Customers can book cabs for return journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Pune to Mumbai Airport Ertiga Cab",
description: "Pune to Mumbai airport Ertiga cab provides reliable transfer for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Ertiga airport cab services."
},
{
name: "Pune to Mumbai Central Cab",
description: "Pune to Mumbai Central cab offers reliable travel for railway station routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Ertiga on Rent in Pune",
description: "Ertiga on rent in Pune offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Ertiga rental services."
},
{
name: "Pune to Mumbai Darshan Ertiga on Rent",
description: "Pune to Mumbai darshan Ertiga on rent offers sightseeing travel for tourists. Customers can book vehicles for city tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga darshan services."
},
{
name: "SRS Cab Service",
description: "SRS cab service provides reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune offers dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab offers reliable transfer services for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab provides reliable intercity transportation for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Ertiga Hire in Pune for Outstation",
description: "Ertiga hire in Pune for outstation offers comfortable travel for long-distance trips. Customers can book vehicles for tours and business travel. Professional drivers ensure safe highway journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Ertiga hire services."
}
],

tableData: [
["Ertiga Per Km Rate in Pune","Pune to Mumbai Airport Ertiga Cab"],
["Pune to Dadar Ertiga Cab Fare","Pune to Andheri Ertiga Taxi Fare"],
["Pune to Mumbai One Way Ertiga Taxi Cab","Ertiga Cab in Pune"],
["Ertiga Cab for Mumbai Airport Drop","Viman Nagar to Mumbai Cabs"],
["Wagholi to Mumbai Cab Service","Pune to Borivali Ertiga Cab"],
["Pune to Andheri Ertiga Cab","Pune to Dadar Ertiga Cab"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai 7 Seater Cab"],
["Pune to Mumbai Cab Round Trip","Pune to Mumbai Airport Ertiga Cab"],
["Pune to Mumbai Central Cab","Ertiga on Rent in Pune"],
["Pune to Mumbai Darshan Ertiga on Rent","SRS Cab Service"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Ertiga Hire in Pune for Outstation"]
],



whychoose: [
  {
    WhyChooseheading: "Spacious Ertiga for Comfortable Travel",
    WhyChoosedescription: "SRS Cab Service offers Pune to Mumbai Ertiga cabs with spacious 6+1 and 7+1 seating, making it perfect for family and group travel."
  },
  {
    WhyChooseheading: "Affordable Ertiga Cab Pricing",
    WhyChoosedescription: "We provide budget-friendly Pune to Mumbai Ertiga cab services with transparent pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced on the Mumbai-Pune Expressway, ensuring safe, fast, and smooth travel."
  },
  {
    WhyChooseheading: "24/7 Ertiga Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Mumbai Ertiga cab bookings, ideal for airport transfers, business trips, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "All Ertiga vehicles are fully air-conditioned, clean, and well-maintained to ensure a comfortable and relaxing journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way Ertiga cab service or round-trip bookings with same-day return options based on your travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Pune",
    WhyChoosedescription: "We provide pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Ertiga Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Mumbai Ertiga cab bookings due to punctual service, professional drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Mumbai Ertiga cab service?", answer: "Yes, SRS Cab Service offers Ertiga cab services from Pune to Mumbai." },
  { question: "How many passengers can travel in Ertiga?", answer: "Ertiga comes with 6+1 and 7+1 seating options suitable for families and small groups." },
  { question: "What is the distance from Pune to Mumbai?", answer: "The distance is approximately 150 km and takes around 3 to 4 hours via expressway." },
  { question: "What is the Ertiga cab fare?", answer: "Ertiga cab fare typically starts from ₹2500–₹3500 depending on availability and timing." },
  { question: "Is one-way Ertiga cab available?", answer: "Yes, one-way Ertiga cab services are available and are more affordable than round trips." },
  { question: "Is service available 24 hours?", answer: "Yes, our cab service operates 24/7." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, we provide drop service to Mumbai Airport including T1 and T2 terminals." },
  { question: "Can I book Ertiga cab online?", answer: "Yes, you can easily book Pune to Mumbai Ertiga cab online or via phone." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles are fully air-conditioned." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked Ertiga from Pune to Mumbai for family trip. Very comfortable and smooth journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Sharma",
    feedback:
      "Best Ertiga cab service. Spacious car, on-time pickup, and professional driver.",
    rating: 5
  }
];























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mumbai Ertiga Cab Service | SRS Cab Service",
  "description": "Book Pune to Mumbai Ertiga cabs for airport transfers, one-way or round trips. 7-seater Ertiga available for comfortable travel from Pune to Mumbai, Dadar, Andheri, Borivali, and more.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-to-mumbai-ertiga-cab",
  "areaServed": ["Pune", "Viman Nagar", "Wagholi", "Mumbai", "Dadar", "Andheri", "Borivali", "Mumbai Airport", "Mumbai Central"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Pune to Mumbai Ertiga Cab",
    "One-way and round-trip Ertiga cabs",
    "Airport drop and pickup",
    "7-seater comfortable travel"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "720"
  }
};



  return (
    <div>
      

<Helmet>
  <title>Pune to Mumbai Ertiga Cab Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Hire Pune to Mumbai Ertiga cabs with SRS Cab Service. One-way, round trip, and airport transfers. Comfortable 7-seater Ertiga available 24x7 online booking."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiertigacab;